export default function isEdgeRow(type) {
  return !!type && (type === 'header' || type === 'total');
}
